import { __exportAll } from "./_virtual/_rolldown/runtime.js";
import "./bite_log_adyen_event.js";
import "./bite_log_card_connect_event.js";
import "./bite_log_chase_event.js";
import "./bite_log_device_event.js";
import "./bite_log_eigen_event.js";
import "./bite_log_elavon_event.js";
import "./bite_log_expo_printer_event.js";
import "./bite_log_fatal_error.js";
import "./bite_log_flash_event.js";
import "./bite_log_freedom_pay_event.js";
import "./bite_log_glory_event.js";
import "./bite_log_heartland_event.js";
import "./bite_log_jtech_table_tracker_event.js";
import "./bite_log_kiosk_event.js";
import "./bite_log_loyalty_event.js";
import "./bite_log_lrs_table_tracker_event.js";
import "./bite_log_maitred_event.js";
import "./bite_log_moneris_event.js";
import "./bite_log_olo_pay_kiosk_event.js";
import "./bite_log_par_pay_event.js";
import "./bite_log_printer_event.js";
import "./bite_log_pusher_event.js";
import "./bite_log_square_event.js";
import "./bite_log_stripe_event.js";
import "./bite_log_transact_campus_card_event.js";
import "./bite_log_type.js";
import "./bite_log_verifone_commander_event.js";
import "./bite_log_verifone_point_cloud_event.js";
import "./bite_log_verifone_point_sca_event.js";
import "./bite_log_worldpay_event.js";
//#region src/bite_log_helper.ts
var bite_log_helper_exports = /* @__PURE__ */ __exportAll({ getSeverity: () => getSeverity });
function getSeverity(type, status) {
	switch (type) {
		case 0: return null;
		case 4:
			if (status === 0) return "recovery";
			return "error";
		case 22: return severityFromAdyenEvent(status);
		case 11: return severityFromCardConnectEvent(status);
		case 28: return severityFromChaseEvent(status);
		case 5: return severityFromDeviceEvent(status);
		case 21: return severityFromEigenEvent(status);
		case 19: return severityFromElavonEvent(status);
		case 17: return severityFromFreedomPayEvent(status);
		case 15: return severityFromHeartlandEvent(status);
		case 13: return severityFromKioskEvent(status);
		case 14: return severityFromLoyaltyEvent(status);
		case 34: return severityFromTransactCampusCardEvent(status);
		case 25: return severityFromLrsTableTrackerEvent(status);
		case 8: return severityFromMaitredEvent(status);
		case 29: return severityFromMonerisEvent(status);
		case 23: return severityFromOloPayKioskEvent(status);
		case 27: return severityFromParPayEvent(status);
		case 1: return severityFromPrinterEvent(status);
		case 9: return severityFromPusherEvent(status);
		case 16: return severityFromStripeEvent(status);
		case 10: return severityFromSquareEvent(status);
		case 12: return severityFromWorldpayEvent(status);
		case 20: return severityFromVerifonePointCloudEvent(status);
		case 24: return severityFromVerifonePointScaEvent(status);
		case 26: return severityFromFlashEvent(status);
		case 30: return severityFromJTechTableTrackerEvent(status);
		case 31: return severityFromGloryEvent(status);
		case 32: return severityFromVerifoneCommanderEvent(status);
		case 33: return severityFromExpoPrinterEvent(status);
	}
}
function severityFromPrinterEvent(event) {
	switch (event) {
		case 0:
		case 23:
		case 24:
		case 25: return null;
		case 5:
		case 1:
		case 2:
		case 15:
		case 9:
		case 3:
		case 14:
		case 11:
		case 4:
		case 7:
		case 8:
		case 21:
		case 20:
		case 22:
		case 18:
		case 19:
		case 16:
		case 17:
		case 6:
		case 26:
		case 27:
		case 29: return "error";
		case 10:
		case 28:
		case 30: return "warning";
	}
}
function severityFromDeviceEvent(event) {
	switch (event) {
		case 50:
		case 56:
		case 53:
		case 55:
		case 59:
		case 61:
		case 60:
		case 0:
		case 31:
		case 35:
		case 57:
		case 58:
		case 47:
		case 52:
		case 37:
		case 74:
		case 79:
		case 67:
		case 44:
		case 71:
		case 75: return null;
		case 38:
		case 30:
		case 21:
		case 48:
		case 29:
		case 20:
		case 26:
		case 51:
		case 43:
		case 12:
		case 68:
		case 49:
		case 69:
		case 72:
		case 28:
		case 6:
		case 36:
		case 46:
		case 41:
		case 40:
		case 42:
		case 39:
		case 66:
		case 22:
		case 23:
		case 24:
		case 25:
		case 45: return "error";
		case 63:
		case 73:
		case 5: return "recovery";
		case 8:
		case 54:
		case 33:
		case 32:
		case 3:
		case 2:
		case 16:
		case 14:
		case 15:
		case 64:
		case 76:
		case 7:
		case 9:
		case 1:
		case 34:
		case 18:
		case 13:
		case 19:
		case 65:
		case 70:
		case 62: return "warning";
	}
}
function severityFromFlashEvent(event) {
	switch (event) {
		case 2:
		case 1: return "warning";
	}
}
function severityFromKioskEvent(event) {
	switch (event) {
		case 11:
		case 45:
		case 0:
		case 16:
		case 1: return null;
		case 12:
		case 44:
		case 46:
		case 47:
		case 37:
		case 32:
		case 42:
		case 17:
		case 21: return "error";
		case 22:
		case 4: return "recovery";
		case 43:
		case 36:
		case 31:
		case 51:
		case 41:
		case 2:
		case 3: return "warning";
	}
}
function severityFromLoyaltyEvent(event) {
	switch (event) {
		case 1:
		case 22:
		case 25:
		case 29:
		case 16:
		case 13:
		case 19:
		case 0:
		case 10:
		case 7:
		case 4:
		case 51:
		case 53:
		case 30:
		case 40:
		case 42: return null;
		case 2:
		case 23:
		case 26:
		case 17:
		case 14:
		case 20:
		case 11:
		case 8:
		case 5:
		case 52:
		case 54:
		case 31:
		case 41:
		case 43:
		case 60: return "error";
		case 3:
		case 24:
		case 27:
		case 61:
		case 18:
		case 15:
		case 21:
		case 12:
		case 28:
		case 9:
		case 6:
		case 32: return "warning";
	}
}
function severityFromMaitredEvent(event) {
	switch (event) {
		case 37:
		case 1700:
		case 1702:
		case 82:
		case 86:
		case 2100:
		case 1500:
		case 1502:
		case 1504:
		case 93:
		case 97:
		case 1001:
		case 1004:
		case 1005:
		case 1003:
		case 94:
		case 0:
		case 201:
		case 207:
		case 151:
		case 206:
		case 126:
		case 131:
		case 401:
		case 501:
		case 551:
		case 553:
		case 101:
		case 603:
		case 601:
		case 901:
		case 911:
		case 701:
		case 703:
		case 801:
		case 850:
		case 71:
		case 205:
		case 21:
		case 1803:
		case 161:
		case 171:
		case 561:
		case 1712:
		case 26:
		case 1800:
		case 24:
		case 23:
		case 121:
		case 11:
		case 62:
		case 13:
		case 14:
		case 65:
		case 111:
		case 113:
		case 564:
		case 48:
		case 204:
		case 210:
		case 224:
		case 221:
		case 231:
		case 237:
		case 225:
		case 227:
		case 235:
		case 954:
		case 105:
		case 107:
		case 234:
		case 338:
		case 351:
		case 335:
		case 301:
		case 356:
		case 353:
		case 367:
		case 369:
		case 365:
		case 311:
		case 385:
		case 331:
		case 321:
		case 324:
		case 329:
		case 327:
		case 359:
		case 362:
		case 364:
		case 1100:
		case 1103:
		case 1200:
		case 36:
		case 1400:
		case 54:
		case 56:
		case 59:
		case 61:
		case 53:
		case 1300:
		case 950:
		case 1921:
		case 1936:
		case 1937:
		case 2e3:
		case 2011:
		case 2012:
		case 2015:
		case 2018:
		case 2301:
		case 2302:
		case 123:
		case 2400: return null;
		case 1600:
		case 1701:
		case 1703:
		case 81:
		case 85:
		case 1501:
		case 1503:
		case 1505:
		case 1506:
		case 92:
		case 96:
		case 1002:
		case 1006:
		case 95:
		case 91:
		case 202:
		case 208:
		case 152:
		case 127:
		case 132:
		case 402:
		case 502:
		case 552:
		case 554:
		case 3:
		case 102:
		case 203:
		case 209:
		case 604:
		case 602:
		case 902:
		case 912:
		case 702:
		case 704:
		case 802:
		case 851:
		case 72:
		case 1804:
		case 162:
		case 172:
		case 562:
		case 1710:
		case 5:
		case 1801:
		case 4:
		case 2:
		case 122:
		case 1:
		case 112:
		case 114:
		case 64:
		case 67:
		case 565:
		case 49:
		case 339:
		case 352:
		case 302:
		case 337:
		case 350:
		case 334:
		case 326:
		case 357:
		case 354:
		case 368:
		case 340:
		case 366:
		case 312:
		case 336:
		case 332:
		case 322:
		case 325:
		case 330:
		case 328:
		case 360:
		case 358:
		case 363:
		case 361:
		case 1102:
		case 1104:
		case 1201:
		case 1401:
		case 55:
		case 57:
		case 58:
		case 60:
		case 2500:
		case 1301:
		case 382:
		case 222:
		case 226:
		case 106:
		case 223:
		case 233:
		case 232:
		case 236:
		case 1900:
		case 1910:
		case 1911:
		case 1912:
		case 1920:
		case 1930:
		case 1931:
		case 1932:
		case 1933:
		case 1934:
		case 2001:
		case 2010:
		case 2013:
		case 2016:
		case 951:
		case 2200:
		case 2401: return "error";
		case 153:
		case 133:
		case 103:
		case 104:
		case 163:
		case 25:
		case 803:
		case 46:
		case 563:
		case 1711:
		case 1802:
		case 47:
		case 63:
		case 66:
		case 12:
		case 566:
		case 50:
		case 303:
		case 355:
		case 313:
		case 381:
		case 333:
		case 323:
		case 1101:
		case 1105:
		case 1402:
		case 952:
		case 955:
		case 1935:
		case 2014:
		case 2017:
		case 953: return "warning";
	}
}
function severityFromMonerisEvent(event) {
	switch (event) {
		case 6:
		case 11:
		case 0:
		case 9:
		case 8:
		case 3:
		case 4:
		case 1:
		case 13: return null;
		case 7:
		case 12:
		case 10:
		case 5: return "error";
		case 2:
		case 14: return "warning";
	}
}
function severityFromPusherEvent(event) {
	switch (event) {
		case 1:
		case 0:
		case 2:
		case 7: return null;
		case 3:
		case 6:
		case 4:
		case 5: return "error";
	}
}
function severityFromSquareEvent(event) {
	switch (event) {
		case 1:
		case 0:
		case 11:
		case 3: return null;
		case 2:
		case 8:
		case 9:
		case 5:
		case 12:
		case 4: return "error";
		case 7:
		case 14:
		case 13:
		case 10:
		case 6: return "warning";
	}
}
function severityFromCardConnectEvent(event) {
	switch (event) {
		case 7: return null;
		case 1:
		case 2: return "warning";
	}
}
function severityFromWorldpayEvent(event) {
	switch (event) {
		case 1:
		case 6:
		case 4:
		case 2: return "warning";
		case 5:
		case 3: return null;
	}
}
function severityFromHeartlandEvent(event) {
	switch (event) {
		case 5:
		case 9:
		case 15:
		case 0:
		case 7:
		case 13:
		case 11:
		case 17: return null;
		case 6:
		case 10:
		case 16:
		case 4:
		case 8:
		case 12:
		case 18: return "error";
		case 14:
		case 1:
		case 2: return "warning";
	}
}
function severityFromStripeEvent(event) {
	switch (event) {
		case 0:
		case 1:
		case 3: return null;
		case 2:
		case 4:
		case 5: return "error";
		case 6: return "warning";
	}
}
function severityFromElavonEvent(event) {
	switch (event) {
		case 0:
		case 3:
		case 5:
		case 7:
		case 9: return null;
		case 4: return "error";
		case 6:
		case 1:
		case 2:
		case 8:
		case 10:
		case 11:
		case 12: return "warning";
	}
}
function severityFromVerifonePointCloudEvent(event) {
	switch (event) {
		case 5: return "warning";
	}
}
function severityFromVerifonePointScaEvent(event) {
	switch (event) {
		case 0:
		case 3:
		case 1: return null;
		case 5:
		case 10:
		case 11:
		case 12:
		case 8:
		case 6:
		case 4:
		case 7: return "error";
		case 13:
		case 14: return "recovery";
		case 9:
		case 2: return "warning";
	}
}
function severityFromEigenEvent(event) {
	switch (event) {
		case 1: return null;
		case 5: return "warning";
	}
}
function severityFromAdyenEvent(event) {
	switch (event) {
		case 5: return "warning";
	}
}
function severityFromOloPayKioskEvent(event) {
	switch (event) {
		case 1:
		case 3: return null;
		case 2:
		case 4: return "error";
		case 5: return "warning";
	}
}
function severityFromFreedomPayEvent(event) {
	switch (event) {
		case 10:
		case 21:
		case 15:
		case 14:
		case 19:
		case 0:
		case 1:
		case 18:
		case 24:
		case 3:
		case 5:
		case 22:
		case 12:
		case 17:
		case 26: return null;
		case 11:
		case 7:
		case 16:
		case 2:
		case 25:
		case 4:
		case 23:
		case 13:
		case 27:
		case 6: return "error";
		case 20:
		case 8:
		case 9: return "warning";
	}
}
function severityFromLrsTableTrackerEvent(event) {
	switch (event) {
		case 21:
		case 11:
		case 15:
		case 3:
		case 1:
		case 30:
		case 40:
		case 16:
		case 4: return null;
		case 22:
		case 2:
		case 13:
		case 31:
		case 32:
		case 17:
		case 5: return "error";
		case 23:
		case 12:
		case 14: return "warning";
	}
}
function severityFromParPayEvent(event) {
	switch (event) {
		case 14:
		case 6:
		case 5:
		case 13:
		case 9:
		case 8:
		case 0:
		case 11:
		case 10:
		case 3:
		case 1:
		case 16: return null;
		case 15:
		case 12:
		case 4: return "error";
		case 7:
		case 2:
		case 17: return "warning";
	}
}
function severityFromChaseEvent(event) {
	switch (event) {
		case 6:
		case 5:
		case 11:
		case 0:
		case 9:
		case 8:
		case 3:
		case 1: return null;
		case 10:
		case 4: return "error";
		case 7:
		case 2: return "warning";
	}
}
function severityFromJTechTableTrackerEvent(event) {
	switch (event) {
		case 0:
		case 1:
		case 4:
		case 6: return null;
		case 2:
		case 5:
		case 7: return "error";
		case 3: return "warning";
	}
}
function severityFromGloryEvent(event) {
	switch (event) {
		case 7:
		case 17:
		case 24:
		case 13:
		case 9:
		case 28:
		case 11:
		case 27:
		case 3:
		case 1:
		case 22:
		case 5:
		case 15:
		case 21:
		case 19:
		case 25: return null;
		case 8:
		case 14:
		case 10:
		case 29:
		case 12:
		case 4:
		case 32: return "warning";
		case 31:
		case 18:
		case 26:
		case 2:
		case 23:
		case 30:
		case 6:
		case 16:
		case 33:
		case 20: return "error";
	}
}
function severityFromTransactCampusCardEvent(event) {
	switch (event) {
		case 1:
		case 3:
		case 5:
		case 7: return null;
		case 9:
		case 2:
		case 8: return "warning";
		case 4:
		case 6:
		case 10:
		case 11: return "error";
	}
}
function severityFromVerifoneCommanderEvent(event) {
	switch (event) {
		case 1:
		case 2:
		case 4:
		case 6:
		case 8:
		case 10:
		case 12:
		case 14:
		case 16:
		case 22:
		case 18:
		case 25:
		case 27:
		case 29:
		case 38:
		case 41:
		case 43: return null;
		case 3:
		case 20:
		case 28:
		case 30: return "warning";
		case 5:
		case 7:
		case 9:
		case 11:
		case 13:
		case 15:
		case 17:
		case 23:
		case 19:
		case 21:
		case 24:
		case 26:
		case 31:
		case 32:
		case 33:
		case 34:
		case 35:
		case 36:
		case 37:
		case 39:
		case 40:
		case 42:
		case 44: return "error";
	}
}
function severityFromExpoPrinterEvent(event) {
	switch (event) {
		case 1:
		case 2: return null;
	}
}
//#endregion
export { bite_log_helper_exports, getSeverity };

//# sourceMappingURL=bite_log_helper.js.map